import { useEffect } from 'react';
import { useField } from 'formik';

export function useInitialValidation({
  fieldName,
  isInitialValidationRequired,
  validateEmail,
}: {
  isInitialValidationRequired: boolean;
  fieldName: string;
  validateEmail: (email: string) => void;
}) {
  const [, meta] = useField(fieldName);
  useEffect(() => {
    if (meta.initialValue && isInitialValidationRequired) {
      validateEmail(meta.initialValue);
    }
  }, [isInitialValidationRequired, meta.initialValue, validateEmail]);
}
